/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { ErrorBoundary as Boundary, } from 'react-error-boundary';
import { Text } from 'react-native';
import { Metric } from '../metrics';
import TENANT_ID from '../config/TenantId';
import { toErrorMessage } from './ErrorHelper';
import Debug from './Debug';
const DefaultFallbackComponent = ({ error }) => {
    if (!__DEV__)
        return null;
    return (React.createElement(Text, null, `UncaughtError:${toErrorMessage(error)}`));
};
export const ErrorBoundary = (props) => {
    const uncaughtErrorHandler = (error, info) => {
        const errorMessage = toErrorMessage(error);
        Metric('UncaughtError', TENANT_ID, {
            attributes: {
                error: errorMessage,
            },
        }).put();
        Debug.error(`Uncaught error ${errorMessage}: ${info.componentStack}`);
    };
    return (React.createElement(Boundary, { FallbackComponent: DefaultFallbackComponent, onError: uncaughtErrorHandler },
        React.createElement(Boundary, Object.assign({ FallbackComponent: DefaultFallbackComponent, onError: uncaughtErrorHandler }, props))));
};
export const withErrorBoundary = (Component, errorBoundaryProps) => (props) => (React.createElement(ErrorBoundary, Object.assign({}, errorBoundaryProps),
    React.createElement(Component, Object.assign({}, props))));
//# sourceMappingURL=ErrorBoundary.js.map